import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Music, LogOut, Shield } from 'lucide-react';

const DashboardHeader = ({ onLogout, currentUser }) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 sm:mb-8 gap-4">
      <div className="flex items-center gap-3 sm:gap-4">
        <div className="flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br from-violet-600 to-purple-600 rounded-xl shadow-lg flex-shrink-0">
          <Music className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Mes Événements
          </h1>
          <p className="text-gray-500 text-xs sm:text-sm">Gérez vos événements musicaux</p>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        {currentUser?.role === 'admin' && (
          <Button
            onClick={() => navigate('/admin')}
            variant="outline"
            size="sm"
            className="border-violet-300 text-violet-600 hover:bg-violet-50 hover:border-violet-400 transition-all duration-200 text-xs sm:text-sm"
          >
            <Shield className="w-4 h-4 sm:mr-2" />
            <span className="hidden sm:inline">Gestion</span>
          </Button>
        )}
        <Button
          data-testid="logout-button"
          onClick={onLogout}
          variant="outline"
          size="sm"
          className="border-gray-300 text-gray-600 hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 text-xs sm:text-sm"
        >
          <LogOut className="w-4 h-4 sm:mr-2" />
          <span className="hidden sm:inline">Déconnexion</span>
        </Button>
      </div>
    </div>
  );
};

export default DashboardHeader;
